import { PricePerMonth } from './PricePerMonth';
import { getShowDiscountedCopy } from './priceUtils';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This component is used to display a price in a given currency with the term.
 * For example, "50/mo" or "50/mo/seat"
 * This differs from the PricePerMonth component in that it takes the PricingInfo object as a prop
 * and then determines whether or not to show the discounted price.
 * This should be a bare-bones component that does not have any additional styling.
 * Any additional styling should be done in the calling component.
 */

export const PriceDisplayWithTerm = ({
  pricingInfo,
  showPricePerMonthPerSeat = false,
  seleniumId,
  currencyCode,
  currencyCodeUnit
}) => {
  const showDiscountedCopy = getShowDiscountedCopy({
    pricingInfo
  });
  const {
    monthly: {
      fullPrice: monthlyFullPrice,
      calculatedPrice: monthlyCalculatedPrice
    }
  } = pricingInfo;
  return /*#__PURE__*/_jsx(PricePerMonth, {
    price: showDiscountedCopy ? monthlyCalculatedPrice : monthlyFullPrice,
    showPricePerMonthPerSeat: showPricePerMonthPerSeat,
    seleniumId: seleniumId,
    currencyCode: currencyCode,
    currencyCodeUnit: currencyCodeUnit
  });
};